import { dawaAutocomplete } from 'dawa-autocomplete2';

window.initializeDawaAutocomplete = function() {
  document.querySelectorAll('.dawa-address-lookup').forEach(elm => {
    dawaAutocomplete(elm, {
      select: selected => {
        var zipElement = document.getElementById('car_owner_zip') || document.getElementById('booking_zip');
        var streetNameElement = document.getElementById('car_owner_street_name') || document.getElementById('booking_street_name');
        var streetNumberElement = document.getElementById('car_owner_street_number') || document.getElementById('booking_street_number');
        var placeElement = document.getElementById('car_owner_place') || document.getElementById('booking_place');
        var premiseElement = document.getElementById('car_owner_premise') || document.getElementById('booking_premise');
        var longitudeElement = document.getElementById('car_owner_longitude') || document.getElementById('booking_longitude');
        var latitudeElement = document.getElementById('car_owner_latitude') || document.getElementById('booking_latitude');

        if (longitudeElement) longitudeElement.value = selected.data.x;
        if (latitudeElement) latitudeElement.value = selected.data.y;
        if (zipElement) zipElement.value = selected.data.postnr;
        if (streetNameElement) streetNameElement.value = selected.data.vejnavn;
        if (streetNumberElement) streetNumberElement.value = selected.data.husnr;
        if (placeElement) placeElement.value = selected.data.postnrnavn;
        if (premiseElement)
          premiseElement.value = [selected.data.etage, selected.data['dør']]
            .filter(x => x !== null)
            .join(' ');
      }
    });
  });
};

window.initializeDawaAutocomplete();

window.initializeGoogleLookup = function() {
  document.querySelectorAll('.google-lookup').forEach((element => {
    var options = {
      componentRestrictions: { country: element.dataset.country },
      types: element.dataset.types.split(',')
    };

    var autocomplete = new google.maps.places.Autocomplete(element, options);

    autocomplete.addListener('place_changed', fillInAddress);

    function fillInAddress() {
      const place = autocomplete.getPlace();
      var zipElement = document.getElementById('car_owner_zip') || document.getElementById('booking_zip');
      var streetNameElement = document.getElementById('car_owner_street_name') || document.getElementById('booking_street_name');
      var streetNumberElement = document.getElementById('car_owner_street_number') || document.getElementById('booking_street_number');
      var placeElement = document.getElementById('car_owner_place') || document.getElementById('booking_place');
      var premiseElement = document.getElementById('car_owner_premise') || document.getElementById('booking_premise');
      var longitudeElement = document.getElementById('car_owner_longitude') || document.getElementById('booking_longitude');
      var latitudeElement = document.getElementById('car_owner_latitude') || document.getElementById('booking_latitude');

      if(longitudeElement) longitudeElement.value = place.geometry.location.lng();
      if(latitudeElement) latitudeElement.value = place.geometry.location.lat();

      for (const component of place.address_components) {
        const componentType = component.types[0];

        switch (componentType) {
          case "street_number": {
            if(streetNumberElement) streetNumberElement.value = component.long_name;
            break;
          }
          case "route": {
            if(streetNameElement) streetNameElement.value = component.short_name;
            break;
          }
          case "postal_code": {
            if(zipElement) zipElement.value = component.long_name;
            break;
          }
          case "postal_town": {
            if(placeElement) placeElement.value = component.long_name;
            break;
          }
        }
      }

    }

    element.addEventListener('keypress', (evt) => {
      if (evt.keyCode === 13) {
        evt.preventDefault();
        // Suppress Google Maps trigger error
        try {
          google.maps.event.trigger(element, 'keydown', { keyCode: 40 });
        } catch (_error) {}
        return false;
      }
    });
  }))
};
